import React from "react";
import "../Css/Sidebar.css";

const Sidebar = () => {
  return <div className="sidebar"></div>;
};

export default Sidebar;
